var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSequelize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 23.58 24.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1dfba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.58,18.63c-3.81,2-7.6,4-11.41,6a.87.87,0,0,1-.67,0Q5.88,21.74.3,18.76A.65.65,0,0,1,0,18.27Q0,12.38,0,6.48A.74.74,0,0,1,.37,6C4,4,7.71,2.08,11.38.13a.81.81,0,0,1,.86,0l11,5.81a.75.75,0,0,1,.37.5C23.59,10.5,23.58,14.56,23.58,18.63Zm-3.36-6.27c0-1.35,0-2.7,0-4a.71.71,0,0,0-.46-.72c-2.51-1.3-5-2.61-7.5-3.92a.82.82,0,0,0-.91,0q-3.74,2-7.5,4a.77.77,0,0,0-.47.78q0,4,0,7.92a.81.81,0,0,0,.51.82c2.5,1.3,5,2.63,7.47,4a.82.82,0,0,0,.91,0c2.49-1.37,5-2.72,7.49-4.06a.76.76,0,0,0,.46-.78C20.2,15,20.22,13.69,20.22,12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.69,12.13c-.5-1.49.49-2.1,1.71-2.79a2.77,2.77,0,0,1,3.07,0,2.75,2.75,0,0,1,1.85,2.89,2.6,2.6,0,0,1-1.55,2.45,3.16,3.16,0,0,1-3.59.06c-1.1-.6-1.77-1.16-1.49-2.37A.88.88,0,0,0,8.69,12.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.69,15.12c1.05.56,2,1,2.89,1.54a.69.69,0,0,0,.79,0c.91-.51,1.85-1,2.88-1.53,0,1.15,0,2.21,0,3.28,0,.13-.18.29-.32.37-.86.48-1.72,1-2.6,1.4a.94.94,0,0,1-.68,0c-.88-.4-1.74-.84-2.6-1.29a.6.6,0,0,1-.32-.42C8.68,17.39,8.69,16.31,8.69,15.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7.56,13.26c-1.07-.54-2-1-3-1.53a.58.58,0,0,1-.25-.46c0-1,0-1.92,0-2.89a.71.71,0,0,1,.35-.52c.83-.49,1.68-.94,2.54-1.39a.69.69,0,0,1,.51-.09c1,.53,2,1.08,3.11,1.67-1,.53-1.89,1-2.8,1.49a.71.71,0,0,0-.47.73C7.58,11.23,7.56,12.19,7.56,13.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.13,13.33c0-1.09,0-2,0-3a.69.69,0,0,0-.46-.72c-.93-.48-1.85-1-2.87-1.53,1.07-.58,2-1.13,3.06-1.65a.64.64,0,0,1,.46.07C17.21,7,18.1,7.47,19,8a.76.76,0,0,1,.33.54c0,.92,0,1.85,0,2.77a.55.55,0,0,1-.2.43C18.16,12.24,17.2,12.75,16.13,13.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.29,12.82c1.08.57,2,1.07,3,1.6a.62.62,0,0,1,.27.45c0,1,0,2,0,3.18-.78-.39-1.46-.79-2.2-1.07a1.4,1.4,0,0,1-1.09-1.65A20.8,20.8,0,0,0,4.29,12.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.91,5.84c-1.06.57-2,1.09-3,1.59a.59.59,0,0,1-.45,0c-1-.52-2-1.05-3.06-1.63,1.05-.56,2-1.1,3-1.61a.61.61,0,0,1,.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.13,18.13c0-1.15,0-2.19,0-3.23a.53.53,0,0,1,.25-.4c.93-.52,1.87-1,2.92-1.58,0,1.17,0,2.26,0,3.34a.32.32,0,0,1-.14.22Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequelize);
export default __webpack_public_path__ + "static/media/sequelize.ea0d7e5ff304f673094bc489f120400d.svg";
export { ForwardRef as ReactComponent };